import Loading from "react-loading";
import "./output.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Nav from "./components/nav";
import LandingPage from "./components/LandingPage";
import { useAppContext } from "./appContext";
import { useLocation, useNavigate } from "react-router-dom";
import { getPaymentInfo, removePaymentInfo } from "./components/Pay";
import { useEffect, useState } from "react";
import { getInfo, removeInfo } from "./components/signup";
import LandingPage_NSBE from "./components/LandingPage_NSBE";

interface AppProps { }

export default function App(props: AppProps): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, reducers, startFunc, stopAudio, navigateThenRun } =
    useAppContext();

  const {
    setloading,
    setcurrentQuestion,
    setcurrScreen,
    setsession,
    setrole,
    settrack,
    setdomain,
    setcustomQ,
    setjobDescriptionQ,
    settype,
    setshowFeedback,
    setshowHistoryModal,
    setintQuestion,
    setqType,
    setdisplayPastFeedback,
    setpastInfo,
    setretryPast,
    setrunSetQs,
    setshowPaymentModal
  } = reducers;
  const [nsbe, setnsbe] = useState(false);
  useEffect(() => {
    const savedPaymentInfo = getPaymentInfo();
    if (savedPaymentInfo) {
      // Use the saved payment info
      setshowPaymentModal(true);
      removePaymentInfo();
    }
    if (getInfo("nsbe")) { //redirect after login
      removeInfo("nsbe");
      setnsbe(true);
    }
  }, []);


  return (
    <>
      {!state.initialLoad && (
        <>
          <Nav />
          <>
            {state.beginningLoad && (
              <div className="loading">
                <Loading
                  type="bubbles"
                  color="#000000"
                  height={200}
                  width={100}
                />
              </div>
            )}
            {!nsbe && <LandingPage />}
            {nsbe && <LandingPage_NSBE />}
          </>
        </>
      )}
      {state.initialLoad && (
        <div className="loading">
          <Loading type="bubbles" color="#000000" height={200} width={100} />
        </div>
      )}
    </>
  );
}
